var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import Theme from 'Theme';
import TicketRenderModal from './TicketRenderModal';
import { typeList } from '../Store';
var TicketDetail = /** @class */ (function (_super) {
    __extends(TicketDetail, _super);
    function TicketDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.findUser = function (lista, id) {
            var result = lista.find(function (value) { return value.id === id; });
            return result ? result.name : '';
        };
        _this.handleOnSelectItem = function (item) {
            console.error(item.id);
        };
        _this.toggle = function () {
            history.goBack();
        };
        _this.refunded = function (response) {
            console.log('refunded');
        };
        return _this;
    }
    TicketDetail.prototype.UNSAFE_componentWillMount = function () {
        if (history.location.state === undefined && !this.props.onToggle) {
            history.goBack();
        }
    };
    TicketDetail.prototype.componentDidMount = function () {
        /*console.log('TicketGratis - componentDidMount')
        this.props.store!.reports.readTicketGratis()*/
    };
    TicketDetail.prototype.render = function () {
        var item = history.location.state || this.props.ticket;
        var onToggle = this.props.onToggle || this.toggle;
        var onRefunded = this.props.onRefunded || this.refunded;
        console.log('***************** tengo que mirar typeReport');
        var externalCloseBtn = React.createElement("button", { className: "close", style: { color: Theme.color.primary, position: 'absolute', top: '50px', right: '15px', }, onClick: onToggle }, "\u00D7");
        return (React.createElement(TicketRenderModal, { ticket: item, onToggle: onToggle, onRefunded: onRefunded, originList: typeList.Report }));
    };
    TicketDetail = __decorate([
        inject('store'),
        observer
    ], TicketDetail);
    return TicketDetail;
}(Component));
export default TicketDetail;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/TicketDetail.tsx
// module id = 1155
// module chunks = 0